export default __webpack_public_path__ + "static/media/white.f496a28b.png";